import React, { useState } from "react";

const MyBooking = () => {

  const [activeTab, setActiveTab] = useState("all");

  const bookings = [
    {
      id: "#TD001234",
      car: "2022 Honda Civic",
      price: "₹12,50,000",
      fuel: "Petrol",
      transmission: "Automatic",
      date: "Dec 25, 2024",
      time: "11:00 AM",
      location: "Koramangala, Bangalore",
      seller: "Amit Kumar",
      status: "confirmed",
      image:
        "https://images.unsplash.com/photo-1606664515524-ed2f786a0bd6?w=400&h=300&fit=crop&auto=format",
    },

    {
      id: "#TD001235",
      car: "2021 BMW X5",
      price: "₹45,00,000",
      fuel: "Diesel",
      transmission: "Automatic",
      date: "Dec 28, 2024",
      time: "3:00 PM",
      location: "Whitefield, Bangalore",
      seller: "Priya Sharma",
      status: "pending",
      image:
        "https://images.unsplash.com/photo-1555215695-3004980ad54e?w=400&h=300&fit=crop&auto=format",
    },
    {
      id: "#TD001233",
      car: "2020 Maruti Swift",
      price: "₹6,50,000",
      fuel: "Petrol",
      transmission: "Manual",
      date: "Dec 20, 2024",
      time: "10:00 AM",
      location: "Jayanagar, Bangalore",
      seller: "Raj Patel",
      status: "completed",
      image:
        "https://images.unsplash.com/photo-1502877338535-766e1452684a?w=400&h=300&fit=crop&auto=format",
    },
    {
      id: "#TD001236",
      car: "2023 Toyota Camry",
      price: "₹28,00,000",
      fuel: "Hybrid",
      transmission: "Automatic",
      date: "Dec 30, 2024",
      time: "2:00 PM",
      location: "Electronic City, Bangalore",
      seller: "Neha Singh",
      status: "confirmed",
      image:
        "https://images.unsplash.com/photo-1621007947382-bb3c3994e3fb?w=400&h=300&fit=crop&auto=format",
    },
    {
      id: "#TD001237",
      car: "2022 Hyundai Creta",
      price: "₹18,50,000",
      fuel: "Petrol",
      transmission: "Automatic",
      date: "Jan 2, 2025",
      time: "4:00 PM",
      location: "Indiranagar, Bangalore",
      seller: "Vikram Reddy",
      status: "confirmed",
      image:
        "https://images.unsplash.com/photo-1549399542-7e3f8b79c341?w=400&h=300&fit=crop&auto=format",
    },
  ];

  const getStatusBadge = (status) => {
    const statusConfig = {
      confirmed: "bg-green-100 text-green-800 border-green-200",
      pending: "bg-yellow-100 text-yellow-800 border-yellow-200",
      completed: "bg-blue-100 text-blue-800 border-blue-200",
    };

    return (
      <span
        className={`px-3 py-1 rounded-full text-xs font-medium border ${statusConfig[status]}`}
      >
        {status.charAt(0).toUpperCase() + status.slice(1)}
      </span>
    );
  };

  const getStatusMessage = (booking) => {
    if (booking.status === "pending") {
      return (
        <div className="mt-4 p-3 bg-yellow-50 border border-yellow-200 rounded-lg">
          <p className="text-sm text-yellow-700 flex items-center space-x-2">
            <span>⏳</span>
            <span>
              Waiting for seller confirmation. You'll receive an SMS once
              confirmed.
            </span>
          </p>
        </div>
      );
    }
    if (booking.status === "completed") {
      return (
        <div className="mt-4 p-3 bg-green-50 border border-green-200 rounded-lg">
          <p className="text-sm text-green-700 flex items-center space-x-2">
            <span>✅</span>
            <span>Test drive completed successfully on {booking.date}</span>
          </p>
        </div>
      );
    }
    return null;
  };

  const filteredBookings =
    activeTab === "all"
      ? bookings
      : bookings.filter((booking) => booking.status === activeTab);

  const getTabCount = (status) => {
    if (status === "all") return bookings.length;
    return bookings.filter((booking) => booking.status === status).length;
  };
  
  return (
    <div className="min-h-screen bg-gradient-to-br from-orange-50 via-white to-blue-50 py-8 px-4">
      <div className="max-w-4xl mx-auto">
        {/* Header */}
        <div className="bg-white rounded-2xl shadow-xl border border-gray-100 mb-6 overflow-hidden">
          <div className="bg-gradient-to-r from-amber-500 to-orange-500 p-6 text-white">
            <div className="flex items-center space-x-3 mb-4">
              <span className="w-8 h-8 bg-white bg-opacity-20 rounded-lg flex items-center justify-center text-white font-bold">
                🚗
              </span>
              <h1 className="text-3xl font-bold">My Test Drive Bookings</h1>
            </div>
            <p className="text-orange-100">
              Manage and track your test drive appointments
            </p>
          </div>

          {/* Summary Stats */}
          <div className="p-6 bg-gray-50">
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
              <div className="bg-white p-4 rounded-xl shadow-sm border border-gray-200">
                <div className="flex items-center space-x-2 mb-2">
                  <span className="text-lg">📊</span>
                  <h4 className="text-sm font-medium text-gray-600">Total</h4>
                </div>
                <p className="text-2xl font-bold text-gray-900">
                  {bookings.length}
                </p>
              </div>
              <div className="bg-white p-4 rounded-xl shadow-sm border border-gray-200">
                <div className="flex items-center space-x-2 mb-2">
                  <span className="text-lg">✅</span>
                  <h4 className="text-sm font-medium text-gray-600">
                    Confirmed
                  </h4>
                </div>
                <p className="text-2xl font-bold text-green-600">
                  {getTabCount("confirmed")}
                </p>
              </div>
              <div className="bg-white p-4 rounded-xl shadow-sm border border-gray-200">
                <div className="flex items-center space-x-2 mb-2">
                  <span className="text-lg">⏳</span>
                  <h4 className="text-sm font-medium text-gray-600">Pending</h4>
                </div>
                <p className="text-2xl font-bold text-yellow-600">
                  {getTabCount("pending")}
                </p>
              </div>
              <div className="bg-white p-4 rounded-xl shadow-sm border border-gray-200">
                <div className="flex items-center space-x-2 mb-2">
                  <span className="text-lg">🎉</span>
                  <h4 className="text-sm font-medium text-gray-600">
                    Completed
                  </h4>
                </div>
                <p className="text-2xl font-bold text-blue-600">
                  {getTabCount("completed")}
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Tabs */}
        <div className="bg-white rounded-2xl shadow-xl border border-gray-100 mb-6 overflow-hidden">
          <div className="p-6 border-b border-gray-100">
            <nav className="flex space-x-1">
              {[
                { key: "all", label: "All Bookings", icon: "📋" },
                { key: "confirmed", label: "Confirmed", icon: "✅" },
                { key: "pending", label: "Pending", icon: "⏳" },
                { key: "completed", label: "Completed", icon: "🎉" },
              ].map((tab) => (
                <button
                  key={tab.key}
                  onClick={() => setActiveTab(tab.key)}
                  className={`flex items-center space-x-2 px-4 py-3 rounded-lg font-medium text-sm transition-all duration-200 ${
                    activeTab === tab.key
                      ? "bg-gradient-to-r from-amber-500 to-orange-500 text-white shadow-lg transform scale-105"
                      : "text-gray-600 hover:text-gray-800 hover:bg-gray-50"
                  }`}
                >
                  <span>{tab.icon}</span>
                  <span>{tab.label}</span>
                  <span
                    className={`px-2 py-1 rounded-full text-xs ${
                      activeTab === tab.key
                        ? "bg-white bg-opacity-20 text-white"
                        : "bg-gray-200 text-gray-600"
                    }`}
                  >
                    {getTabCount(tab.key)}
                  </span>
                </button>
              ))}
            </nav>
          </div>
        </div>

        {/* Bookings List - Vertical Cards */}
        <div className="space-y-6">
          {filteredBookings.map((booking) => (
            <div
              key={booking.id}
              className="bg-white rounded-2xl shadow-xl border border-gray-100 hover:shadow-2xl transform hover:scale-[1.02] transition-all duration-300 overflow-hidden"
            >
              <div className="flex flex-col md:flex-row">
                {/* Left Side - Car Image */}
                <div className="md:w-80 md:flex-shrink-0">
                  <div className="h-64 md:h-full relative overflow-hidden">
                    <img
                      src={booking.image}
                      alt={booking.car}
                      className="w-full h-full object-cover"
                    />
                    <div className="absolute top-4 right-4">
                      {getStatusBadge(booking.status)}
                    </div>
                    <div className="absolute bottom-4 left-4 bg-black bg-opacity-70 text-white px-3 py-2 rounded-lg">
                      <div className="text-xs text-gray-300">Booking ID</div>
                      <div className="font-semibold">{booking.id}</div>
                    </div>
                  </div>
                </div>

                {/* Right Side - Content */}
                <div className="flex-1 p-6">
                  <div className="flex flex-col h-full">
                    {/* Header */}
                    <div className="mb-4">
                      <h3 className="text-xl font-bold text-gray-900 mb-2">
                        {booking.car}
                      </h3>
                      <div className="text-2xl font-bold text-green-600 mb-3 flex items-center space-x-2">
                        <span>💰</span>
                        <span>{booking.price}</span>
                      </div>
                      <div className="flex gap-2">
                        <span className="px-3 py-1 bg-gradient-to-r from-blue-100 to-blue-200 text-blue-800 text-xs rounded-full font-medium">
                          ⛽ {booking.fuel}
                        </span>
                        <span className="px-3 py-1 bg-gradient-to-r from-purple-100 to-purple-200 text-purple-800 text-xs rounded-full font-medium">
                          ⚙️ {booking.transmission}
                        </span>
                      </div>
                    </div>

                    {/* Details */}
                    <div className="flex-1 mb-4">
                      <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
                        <div className="flex items-center text-sm bg-gray-50 p-3 rounded-lg">
                          <div className="w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center mr-3">
                            <span>📅</span>
                          </div>
                          <div>
                            <span className="font-medium text-gray-900 block">
                              Date & Time
                            </span>
                            <p className="text-gray-600">
                              {booking.date} • {booking.time}
                            </p>
                          </div>
                        </div>

                        <div className="flex items-center text-sm bg-gray-50 p-3 rounded-lg">
                          <div className="w-8 h-8 bg-green-100 rounded-full flex items-center justify-center mr-3">
                            <span>📍</span>
                          </div>
                          <div>
                            <span className="font-medium text-gray-900 block">
                              Location
                            </span>
                            <p className="text-gray-600">{booking.location}</p>
                          </div>
                        </div>

                        <div className="flex items-center text-sm bg-gray-50 p-3 rounded-lg">
                          <div className="w-8 h-8 bg-purple-100 rounded-full flex items-center justify-center mr-3">
                            <span>👤</span>
                          </div>
                          <div>
                            <span className="font-medium text-gray-900 block">
                              Seller
                            </span>
                            <p className="text-gray-600">{booking.seller}</p>
                          </div>
                        </div>
                      </div>

                      {getStatusMessage(booking)}
                    </div>

                    {/* Action Buttons */}
                    <div className="flex gap-3">
                      {booking.status === "confirmed" && (
                        <>
                          <button className="flex-1 bg-gradient-to-r from-amber-500 to-orange-500 text-white px-4 py-3 rounded-lg text-sm font-semibold hover:from-orange-600 hover:to-red-600 transform hover:scale-105 transition-all duration-200 shadow-lg flex items-center justify-center space-x-2">
                            <span>👁️</span>
                            <span>View Details</span>
                          </button>
                          <button className="px-4 py-3 border-2 border-gray-300 text-gray-700 rounded-lg text-sm font-semibold hover:bg-gray-50 hover:border-gray-400 transition-all duration-200 flex items-center justify-center space-x-2">
                            <span>🔄</span>
                            <span>Reschedule</span>
                          </button>
                        </>
                      )}
                      {booking.status === "pending" && (
                        <>
                          <button className="flex-1 bg-gradient-to-r from-yellow-500 to-orange-500 text-white px-4 py-3 rounded-lg text-sm font-semibold hover:from-orange-600 hover:to-red-600 transform hover:scale-105 transition-all duration-200 shadow-lg flex items-center justify-center space-x-2">
                            <span>📞</span>
                            <span>Contact Seller</span>
                          </button>
                          <button className="px-4 py-3 border-2 border-red-300 text-red-700 rounded-lg text-sm font-semibold hover:bg-red-50 hover:border-red-400 transition-all duration-200 flex items-center justify-center space-x-2">
                            <span>❌</span>
                            <span>Cancel</span>
                          </button>
                        </>
                      )}
                      {booking.status === "completed" && (
                        <>
                          <button className="flex-1 bg-gradient-to-r from-green-500 to-blue-500 text-white px-4 py-3 rounded-lg text-sm font-semibold hover:from-blue-600 hover:to-purple-600 transform hover:scale-105 transition-all duration-200 shadow-lg flex items-center justify-center space-x-2">
                            <span>⭐</span>
                            <span>Write Review</span>
                          </button>
                          <button className="px-4 py-3 border-2 border-gray-300 text-gray-700 rounded-lg text-sm font-semibold hover:bg-gray-50 hover:border-gray-400 transition-all duration-200 flex items-center justify-center space-x-2">
                            <span>🔄</span>
                            <span>Book Again</span>
                          </button>
                        </>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {filteredBookings.length === 0 && (
          <div className="bg-white rounded-2xl shadow-xl border border-gray-100 p-12 text-center">
            <div className="w-20 h-20 bg-gradient-to-br from-gray-100 to-gray-200 rounded-full mx-auto mb-6 flex items-center justify-center">
              <span className="text-3xl">🚗</span>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-3">
              No bookings found
            </h3>
            <p className="text-gray-600 mb-6">
              You don't have any {activeTab} test drive bookings.
            </p>
            <button className="bg-gradient-to-r from-amber-500 to-orange-500 text-white px-6 py-3 rounded-lg font-semibold hover:from-orange-600 hover:to-red-600 transform hover:scale-105 transition-all duration-200 shadow-lg flex items-center space-x-2 mx-auto">
              <span>➕</span>
              <span>Book New Test Drive</span>
            </button>
          </div>
        )}
      </div>
    </div>
  );
};
export default MyBooking;
